// extracted by mini-css-extract-plugin
export default {"container":"container--y1k6MD7K"};